<div class="p-3">
  <div class="page-header mb-4">
    <div class="d-flex justify-content-between align-items-center">
      <div>
        <h4 class="mb-1">
          {{ stepDetails?.name }}
        </h4>
        <h5 class="text-primary">[{{ payload?.proposal_name }}]</h5>
        
      </div>

      <div class="action-buttons">
        <!-- <button class="btn btn-outline-secondary me-2" (click)="generatePDF()">
          <i class="pi pi-file-pdf me-1"></i> PDF
        </button> -->


        <ng-container *ngIf="stepDetails?.can_edit">
          <button class="btn btn-primary me-2" (click)="routeConfig.emit({isRouteConfig: true})" >
            <i class="pi pi-save me-1"></i> Save/Forward/Route Config
          </button>
        </ng-container>

       
      </div>
    </div>
  </div>

  <hr class="my-3" />


  <form [formGroup]="benchmarkForm">

    <div class="row mb-4">
       <div class="col-md-4 d-flex gap-2">
              <label class="bg-primary text-white p-2 " for="bid_opening_date">Technical Bid Opening Date <b class="text-warning">*</b></label>
      <input inputId="bid_opening_date" type="date" formControlName="bid_opening_date" [disabled]="isEditorDisabled"  class="w-100px" />
      </div>
      <div class="col-md-4 d-flex gap-2">
              <label class="bg-primary text-white p-2 " for="bid_opening_time">Technical Bid Opening Time <b class="text-warning">*</b></label>
             <input inputId="bid_opening_time" type="time" formControlName="bid_opening_time" [disabled]="isEditorDisabled"  class="w-100px" />
      </div>
       <div class="col-md-4 d-flex gap-2">
             <label class="bg-primary text-white p-2 " for="technical_bid_venue">Technical Bid Opening Venue <b class="text-warning">*</b></label>
      <input inputId="technical_bid_venue" formControlName="technical_bid_venue" [disabled]="true" class="w-100px" />
      </div>
    </div>
   
     <div class="row">
      <div class="col-md-6 d-flex gap-2">
             <label class="bg-primary text-white p-2 " for="benchmark_price">Benchmark Price <b class="text-warning">*</b></label>
      <input inputId="benchmark_price" formControlName="benchmark_price" [disabled]="true" class="w-100px" />
      </div>
      <!-- <div class="col-md-6 d-flex gap-2">
             <label class="bg-primary text-white p-2 " for="technical_bid_venue">Technical Bid Opening Venue <b class="text-warning">*</b></label>
      <input inputId="technical_bid_venue" formControlName="technical_bid_venue" [disabled]="true" class="w-100px" />
      </div> -->
      <!-- <div class="col-md-4 d-flex gap-2">
              <label class="bg-primary text-white p-2 " for="bid_opening_date">Bid Opening Date <b class="text-warning">*</b></label>
      <input inputId="bid_opening_date" type="date" formControlName="bid_opening_date" [disabled]="isEditorDisabled"  class="w-100px" />
      </div>
      <div class="col-md-4 d-flex gap-2">
              <label class="bg-primary text-white p-2 " for="bid_opening_time">Bid Opening Time <b class="text-warning">*</b></label>
             <input inputId="bid_opening_time" type="time" formControlName="bid_opening_time" [disabled]="isEditorDisabled"  class="w-100px" />
      </div> -->
    </div>
    

  </form>

  <!-- Benchmark Dates Section -->
  <div class="mt-3 mb-4">
    <div *ngIf="stepDetails?.can_edit" class="d-flex justify-content-end mb-2">
      <button class="add-btn bg-primary text-white py-2 px-3" (click)="addBenchmarkDateRow()">+ Add Row</button>
    </div>
    <table class="custom-table table mb-4">
      <thead>
        <tr>
          <th class="bg-primary text-white py-2">Benchmarking Meeting</th>
          <th class="bg-primary text-white py-2">Held On</th>
          <th *ngIf="stepDetails?.can_edit" class="bg-primary text-white py-2">Action</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let row of benchmarkDates; let i = index">
          <td>
            <ng-container *ngIf="row.edit; else nameDisplay">
              <input type="text" class="form-control" [(ngModel)]="row.name" />
            </ng-container>
            <ng-template #nameDisplay>{{ row.name }}</ng-template>
          </td>
          <td>
            <ng-container *ngIf="row.edit; else dateDisplay">
              <input type="date" class="form-control" [(ngModel)]="row.date" />
            </ng-container>
            <ng-template #dateDisplay>{{ row.date }}</ng-template>
          </td>
          <td>
            <ng-container *ngIf="stepDetails?.can_edit">
              <button class="btn btn-sm btn-outline-primary me-1" *ngIf="!row.edit" (click)="row.edit = true">Edit</button>
              <button class="btn btn-sm btn-success" *ngIf="row.edit" (click)="saveBenchmarkDateRow(row)">Save</button>
            </ng-container>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <form [formGroup]="benchmarkForm">
    <div class="form-group mb-4 editor-container mt-4" [class.readonly-editor]="isEditorDisabled">
      <label class="bg-primary text-white p-2 " for="pdsTitle"><strong>• {{ schemeType === 'rev' ? 'Comment' : 'Justification' }}</strong></label>
      <editor [init]="init" formControlName="comment" [disabled]="isEditorDisabled">
      </editor>
    </div>
  </form>

   <!-- Document Upload Section -->
  <div class="mt-4 mb-4">
    <app-upload-document [isEditable]="stepDetails?.can_edit"  [title]="'MOM Upload Documents'"></app-upload-document>
  </div>

  
  
<!-- 
  <div class="d-flex justify-content-end mb-2"
    *ngIf="stepDetails?.can_edit">
    <button pButton type="button" label="Add Vendor" icon="pi pi-plus" (click)=" showAddDialogPopup()"
      class="fetch-data-btn"></button>
  </div>
  <div class="overflow-x-auto">
    <p-table [value]="vendors">
      <ng-template pTemplate="header">
        <tr>
          <th>Vendor Name</th>
          <th>Vendor Address</th>
          <th>Budgetory Quote</th>
          <th>Upload Doc</th>
          <th
            *ngIf="stepDetails?.is_initiator || stepDetails?.is_approver || stepDetails?.is_recommender|| (stepDetails?.step_status != 'approved' && userID == 6)">
            Actions</th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-rowData let-rowIndex="rowIndex">
        <tr>
          <td>{{ rowData.vendor_name }}</td>
          <td>{{ rowData.vendor_address }}</td>
          <td>{{ rowData.benchmark_price }}</td>
          <td>
            <a *ngIf="rowData.document; else noFile" [href]="apiUrl + rowData.file" target="_blank" class="file-name">
              {{ getFileName(rowData.document) }}
            </a>
            <ng-template #noFile>No file</ng-template>
          </td>
          <td
            *ngIf="stepDetails?.is_initiator || stepDetails?.is_approver || stepDetails?.is_recommender|| (stepDetails?.step_status != 'approved' && userID == 6)">
            <button pButton icon="pi pi-pencil" class="p-button-text fetch-data-btn"
              (click)="onEditVendor(rowData, rowIndex)"></button>
          </td>
        </tr>
      </ng-template>
    </p-table>

  </div>



  <p-dialog header="{{ isEditMode ? 'Edit Vendor' : 'Add New Vendor' }}" [(visible)]="showAddDialog" [modal]="true"
    [style]="{width: '500px'}" [closable]="true" [dismissableMask]="true" appendTo="body" [maximizable]="true">

    <form [formGroup]="vendorForm" class="p-fluid mt-4 mb-4">
      <div class="field">
        <label for="vendorName">Vendor Name</label>
        <input id="vendorName" pInputText formControlName="vendor_name" />
      </div>

      <div class="field">
        <label for="vendorAddress">Vendor Address</label>
        <input id="vendorAddress" pInputText formControlName="vendor_address" />
      </div>

      <div class="field">
        <label for="benchmarkPrice">Benchmark Price</label>
        <input id="benchmarkPrice" type="number" pInputText formControlName="benchmark_price" />
      </div>

      <div class="field">
        <label for="upload">Upload Document</label>
        <input #fileInput type="file" (change)="onNewVendorFileUpload($event)" />
        <div *ngIf="vendorForm.value.document && vendorForm.value.document.name">
          Selected: {{ vendorForm.value.document.name }}
        </div>
        <div *ngIf="vendorForm.value.document && !vendorForm.value.document.name">
          Existing:
          <a [href]="apiUrl + vendorForm.value.document" target="_blank">
            {{ getFileName(vendorForm.value.document) }}
          </a>
        </div>
      </div>

      <div class="d-flex justify-content-end mt-4">
        <button pButton label="Submit" class="p-button-sm p-button-info fetch-data-btn" (click)="submitVendor()"
          [disabled]="vendorForm.invalid">
        </button>
      </div>
    </form>

  </p-dialog> -->